import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';

const SidebarQuoteAi = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const sections = [
    {
      name: 'Insured Information',
      path: '/quoteAI/insuredInformationPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-file-text h-3.5 w-3.5 mr-1.5"
        >
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M10 9H8"></path>
          <path d="M16 13H8"></path>
          <path d="M16 17H8"></path>
        </svg>
      ),
      status: 'completed',
    },

    {
      name: 'Contact Information',
      path: '/quoteAI/contactInformationPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-users h-3.5 w-3.5 mr-1.5"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
      status: 'in-progress',
    },
    {
      name: 'Policy Term',
      path: '/quoteAI/policyTermPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-building h-3.5 w-3.5 mr-1.5"
        >
          <rect width="16" height="20" x="4" y="2" rx="2" ry="2"></rect>
          <path d="M9 22v-4h6v4"></path>
          <path d="M8 6h.01"></path>
          <path d="M16 6h.01"></path>
          <path d="M12 6h.01"></path>
          <path d="M12 10h.01"></path>
          <path d="M12 14h.01"></path>
          <path d="M16 10h.01"></path>
          <path d="M16 14h.01"></path>
          <path d="M8 10h.01"></path>
          <path d="M8 14h.01"></path>
        </svg>
      ),
      status: 'error',
      errorCount: 2,
    },
    {
      name: 'Locations',
      path: '/quoteAI/locationPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-map-pin h-3.5 w-3.5 mr-1.5"
        >
          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
      ),
    },
    {
      name: 'Location Class Codes',
      path: '/quoteAI/locationClassCodePage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-dollar-sign h-3.5 w-3.5 mr-1.5"
        >
          <line x1="12" x2="12" y1="2" y2="22"></line>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
        </svg>
      ),
    },
    {
      name: 'Pre-Qualifier Questions',
      path: '/quoteAI/preQualifierQuestionPage',
      icon: (
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm1 15h-2v-2h2zm0-4h-2V7h2z" />
        </svg>
      ),
    },
    {
      name: 'Rating Information',
      path: '/quoteAI/ratingInformationPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-shield h-3.5 w-3.5 mr-1.5"
        >
          <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
        </svg>
      ),
    },
    {
      name: 'Deductibles',
      path: '/quoteAI/deductiblePage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-wallet h-3.5 w-3.5 mr-1.5"
        >
          <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
          <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
        </svg>
      ),
    },
    {
      name: 'Loss Details',
      path: '/quoteAI/lossDetailPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-file-chart-column-increasing h-3.5 w-3.5 mr-1.5"
        >
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M8 18v-2"></path>
          <path d="M12 18v-4"></path>
          <path d="M16 18v-6"></path>
        </svg>
      ),
    },
    {
      name: 'Included Excluded Officers',
      path: '/quoteAI/includedExcludedOfficerPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-user-cog h-3.5 w-3.5 mr-1.5"
        >
          <circle cx="18" cy="15" r="3"></circle>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M10 15H6a4 4 0 0 0-4 4v2"></path>
          <path d="m21.7 16.4-.9-.3"></path>
          <path d="m15.2 13.9-.9-.3"></path>
          <path d="m16.6 18.7.3-.9"></path>
          <path d="m19.1 12.2.3-.9"></path>
          <path d="m19.6 18.7-.4-1"></path>
          <path d="m16.8 12.3-.4-1"></path>
          <path d="m14.3 16.6 1-.4"></path>
          <path d="m20.7 13.8 1-.4"></path>
        </svg>
      ),
    },
    {
      name: 'Underwriting Information',
      path: '/quoteAI/underwritingInformationPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-triangle-alert h-3.5 w-3.5 mr-1.5"
        >
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>
          <path d="M12 9v4"></path>
          <path d="M12 17h.01"></path>
        </svg>
      ),
    },
    {
      name: 'Additional Information Forms',
      path: '/quoteAI/additionalFormPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-file-spreadsheet h-3.5 w-3.5 mr-1.5"
        >
          <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
          <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
          <path d="M8 13h2"></path>
          <path d="M14 13h2"></path>
          <path d="M8 17h2"></path>
          <path d="M14 17h2"></path>
        </svg>
      ),
    },
    {
      name: 'Quoted Premium',
      path: '/quoteAI/quotedPremiumPage',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-receipt h-3.5 w-3.5 mr-1.5"
        >
          <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
          <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
          <path d="M12 17.5v-11"></path>
        </svg>
      ),
    },
  ];

  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const current = sections.find((section) => section.path === location.pathname);
    if (current) {
      setActiveSection(current.name);
    }
  }, [location.pathname]);

  const handleItemClick = (section) => {
    setActiveSection(section.name);
    navigate(section.path);
  };

  const statusColors = {
    'not-started': 'bg-gray-400',
    'in-progress': 'bg-yellow-500',
    completed: 'bg-green-500',
    error: 'bg-red-500',
  };
  const isActive = (path) => location.pathname === path;

  return (
    <div id="editQuoteAiSidebar">
      <div className="sidebar-Edit-container">
        {sections.map((section, index) => (
          <div
            key={index}
            className={`sidebar-item 
          ${activeSection === section.name ? 'checked' : ''} 
          ${section.status === 'completed' ? 'sidebar-completed' : ''} 
          ${section.status === 'in-progress' ? 'sidebar-progress' : ''} 
          ${section.status === 'error' ? 'sidebar-error' : ''}
          ${!section.status ? 'sidebar-notstarted' : ''}
        `}
            onClick={() => handleItemClick(section)}
          >
            <span className="sidebar-icon">{section.icon}</span>
            <span className="sidebar-label">{section.name}</span>

            {/* Status Indicator with Tooltip */}
            {section.status && (
              <div
                data-tooltip-id={`status-tooltip-${index}`}
                data-tooltip-content={
                  section.status === 'completed'
                    ? 'Completed'
                    : section.status === 'in-progress'
                      ? 'In Progress'
                      : section.status === 'error'
                        ? 'Has Errors'
                        : section.status === 'not-started'
                          ? 'Not Started'
                          : 'Unknown'
                }
                className="flex items-center ms-auto space-x-1"
              >
                <ReactTooltip
                  id={`status-tooltip-${index}`}
                  place="right"
                  style={{
                    backgroundColor: '#2563eb',
                    color: '#fff',
                    fontSize: '12px',
                    borderRadius: '6px',
                  }}
                />

                {/* Status dot */}
                <span
                  className={`w-2 h-2 rounded-full ${statusColors[section.status]}`}
                  title={section.status}
                ></span>

                {/* Error count */}
                {section.status === 'error' && section.errorCount ? (
                  <span className="text-xs text-red-600 ml-1">({section.errorCount})</span>
                ) : null}

                {/* Completed: check icon */}
                {section.status === 'completed' && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="green"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check ml-1 h-4 w-4 text-green-500"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                )}

                {/* In-progress: dashed circle icon */}
                {section.status === 'in-progress' && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#b8860b"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-circle-dashed ml-1 h-4 w-4 text-amber-500"
                  >
                    <path d="M10.1 2.182a10 10 0 0 1 3.8 0" />
                    <path d="M13.9 21.818a10 10 0 0 1-3.8 0" />
                    <path d="M17.609 3.721a10 10 0 0 1 2.69 2.7" />
                    <path d="M2.182 13.9a10 10 0 0 1 0-3.8" />
                    <path d="M20.279 17.609a10 10 0 0 1-2.7 2.69" />
                    <path d="M21.818 10.1a10 10 0 0 1 0 3.8" />
                    <path d="M3.721 6.391a10 10 0 0 1 2.7-2.69" />
                    <path d="M6.391 20.279a10 10 0 0 1-2.69-2.7" />
                  </svg>
                )}

                {/* Error: alert circle icon */}
                {section.status === 'error' && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="red"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-circle-alert ml-1 h-4 w-4 text-red-600"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" x2="12" y1="8" y2="12" />
                    <line x1="12" x2="12.01" y1="16" y2="16" />
                  </svg>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SidebarQuoteAi;
